import { FC, ReactNode } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import styles from "./LoginCard.module.css";
import Translated from "../infrastructure/translation/Translated";
import { findURIAndReplaceOrigin } from "../infrastructure/entrypoint/link";
import { useEntrypointContext } from "../infrastructure/entrypoint/EntrypointContext";
import { TranslationKey } from "../infrastructure/translation/translator";

type Props = {
  loginMethod?: "nbid" | "buypass";
  title: TranslationKey;
  description: TranslationKey;
  logo: ReactNode;
};

export const LoginCard: FC<Props> = ({
  loginMethod,
  title,
  description,
  logo,
}) => {
  const entrypoint = useEntrypointContext();

  const loginUrl =
    findURIAndReplaceOrigin("login", entrypoint._links) +
    "&idpPreselect=" +
    loginMethod;

  return (
    <li className={styles.card}>
      <a href={loginUrl} className={styles.link}>
        <span className={styles.logo}>{logo}</span>
        <span className={styles.content}>
          <span className={styles.title}>
            <Translated textKey={title} />
          </span>
          <span className={styles.meta}>
            <Translated textKey={description} />
          </span>
        </span>
        <FontAwesomeIcon
          icon={faChevronRight}
          className={styles.chevron}
          aria-hidden
        />
      </a>
    </li>
  );
};
